export function getFileType(file) {
  return file?.type?.split("/")[0] || "unknown";
}